/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setLocationPermission} from '../api'

export const useMutationSetLocationPermission = createReactQueryMutationHook('setLocationPermission', setLocationPermission)
